import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('./components/Home'));
const ProjectDetail = lazy(() => import('./components/ProjectDetail'));
const CategoryGallery = lazy(() => import('./components/CategoryGallery'));
const NotFound = lazy(() => import('./components/NotFound'));
const Success = lazy(() => import('./components/Success'));
const Press = lazy(() => import('./components/Press'));
const SaskatoonMurals = lazy(() => import('./components/SaskatoonMurals'));
const BlogSection = lazy(() => import('./components/BlogSection'));
const BlogPost = lazy(() => import('./components/BlogPost'));
const Test360Page = lazy(() => import('./components/Test360Page'));

export const routes: RouteObject[] = [
    {
        index: true,
        Component: Home,
    },
    {
        path: 'work/category/:category',
        Component: CategoryGallery,
    },
    {
        path: 'work/:slug',
        Component: ProjectDetail,
    },
    {
        path: 'press',
        Component: Press,
    },
    {
        path: 'saskatoon-murals',
        Component: SaskatoonMurals,
    },
    {
        path: 'thanks',
        Component: Success,
    },
    {
        path: 'blog',
        Component: BlogSection,
    },
    {
        path: 'blog/:slug',
        Component: BlogPost,
    },
    {
        path: 'test-360',
        Component: Test360Page,
    },
    {
        path: '*',
        Component: NotFound,
    },
];
